export function setPageinfoLoading (state, loading = false) {
  state.pageinfoLoading = loading
}
